var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5 pt-5" },
    [
      _vm.loadingState || _vm.loadingState2 ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container  mt-3" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "row justify-content-center pt- mb-5" }, [
          _c(
            "div",
            { staticClass: "col-md-6 col-lg-4 pt-4 pb-4 vaillantCont" },
            [
              _c(
                "form",
                {
                  staticClass: "login widthFull",
                  attrs: { id: "login-form" },
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.login($event)
                    }
                  }
                },
                [
                  _vm.confirmed && !_vm.to_activate
                    ? _c("div", { staticClass: "widthFull" }, [
                        _c(
                          "div",
                          { staticClass: "form-row justify-content-center" },
                          [
                            _c("div", { staticClass: "col-md-12 mb-1" }, [
                              _c("div", { staticClass: "group custInput" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.username,
                                      expression: "username"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: {
                                        required: true,
                                        email: true,
                                        temporaryEmail: true,
                                        plusIssueEmail: true,
                                        max: 56
                                      },
                                      expression:
                                        "{required:true,email: true, temporaryEmail:true, plusIssueEmail: true, max: 56}"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: {
                                    "is-invalid": _vm.errors.has("username"),
                                    valid: !!_vm.username
                                  },
                                  attrs: {
                                    type: "text",
                                    id: "username",
                                    name: "username",
                                    "data-vv-as": "Email"
                                  },
                                  domProps: { value: _vm.username },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.username = $event.target.value
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "highlight" }),
                                _vm._v(" "),
                                _c("span", { staticClass: "bar" }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "niceInputLabel",
                                    attrs: { for: "username" }
                                  },
                                  [_vm._v("Email")]
                                ),
                                _vm._v(" "),
                                _vm.errors.has("username")
                                  ? _c(
                                      "div",
                                      { staticClass: "invalid-feedback" },
                                      [
                                        _vm._v(
                                          "\r\n                    " +
                                            _vm._s(
                                              _vm.errors.first("username")
                                            ) +
                                            "\r\n\r\n                  "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.socialEmail
                                  ? _c(
                                      "div",
                                      { staticClass: "text-danger mt-3" },
                                      [
                                        _vm._v(
                                          "\r\n                    Sei registrato con: "
                                        ),
                                        _c(
                                          "strong",
                                          { staticClass: "text-capitalize" },
                                          [_vm._v(_vm._s(_vm.socialEmail))]
                                        ),
                                        _vm._v(
                                          ". Per effetuare accesso clicca sulla apposita icona\r\n                  "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-row justify-content-center" },
                          [
                            _c("div", { staticClass: "col-md-12 mb-3" }, [
                              _c("div", { staticClass: "group custInput" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.password,
                                      expression: "password"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: {
                                        required: true,
                                        min: 8,
                                        max: 56
                                      },
                                      expression:
                                        "{required:true, min: 8, max: 56}"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: {
                                    "is-invalid": _vm.errors.has("password"),
                                    valid: !!_vm.password
                                  },
                                  attrs: {
                                    type: "password",
                                    id: "password",
                                    name: "password",
                                    "data-vv-as": "Password"
                                  },
                                  domProps: { value: _vm.password },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.password = $event.target.value
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "highlight" }),
                                _vm._v(" "),
                                _c("span", { staticClass: "bar" }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "niceInputLabel",
                                    attrs: { for: "password" }
                                  },
                                  [_vm._v("Password")]
                                ),
                                _vm._v(" "),
                                _vm.errors.has("password")
                                  ? _c(
                                      "div",
                                      { staticClass: "invalid-feedback" },
                                      [
                                        _vm._v(
                                          "\r\n                    " +
                                            _vm._s(
                                              _vm.errors.first("password")
                                            ) +
                                            "\r\n                  "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.loginerror
                                  ? _c("div", { staticClass: "mb-3" }, [
                                      _c(
                                        "span",
                                        { staticClass: "formError ml-1" },
                                        [_vm._v("Email o password errati.")]
                                      )
                                    ])
                                  : _vm._e()
                              ])
                            ])
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.confirmed && !_vm.to_activate
                    ? _c("div", { staticClass: "widthFull" }, [
                        _c(
                          "div",
                          { staticClass: "form-row justify-content-center" },
                          [
                            _vm.hasregistration
                              ? _c(
                                  "div",
                                  { staticClass: "col-md-12 mb-3" },
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        staticClass: "black Medium pl-3 ",
                                        attrs: { to: "/forgot-password" }
                                      },
                                      [_vm._v("Password dimenticata?")]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-row justify-content-center" },
                          [
                            _vm._m(1),
                            _vm._v(" "),
                            _vm.social
                              ? _c(
                                  "div",
                                  { staticClass: "text-danger mb-5 " },
                                  [
                                    _vm._v(
                                      "\r\n                Sei registrato con altra social network: "
                                    ),
                                    _c(
                                      "strong",
                                      { staticClass: "text-capitalize" },
                                      [_vm._v(_vm._s(_vm.social))]
                                    ),
                                    _vm._v(
                                      " Per effetuare accesso clicca sulla apposita icona\r\n              "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      ])
                    : _vm._e()
                ]
              )
            ]
          ),
          _vm._v(" "),
          _vm._m(2),
          _vm._v(" "),
          _vm.hasregistration
            ? _c(
                "div",
                {
                  staticClass: "col-md-6 col-lg-4 pt-1 pb-4 mb-5 vaillantCont"
                },
                [
                  _vm.confirmed && !_vm.to_activate
                    ? _c("div", [
                        _c(
                          "div",
                          { staticClass: "form-row justify-content-center" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "col-md-12 mb-0 pb-0 text-center"
                              },
                              [
                                _vm.moment(_vm.finish) > _vm.moment()
                                  ? _c(
                                      "h1",
                                      {},
                                      [
                                        _c(
                                          "h4",
                                          {
                                            staticClass:
                                              " Regular center glade pb-2"
                                          },
                                          [_vm._v("Non sei registrato?")]
                                        ),
                                        _vm._v(" "),
                                        !_vm.isAuthenticated
                                          ? _c(
                                              "router-link",
                                              {
                                                staticClass:
                                                  "btn btn-primary  btnYellow",
                                                attrs: { to: "/registration" }
                                              },
                                              [
                                                _vm._v(
                                                  "\r\n                  Registrati\r\n                "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            )
                          ]
                        )
                      ])
                    : _vm.resend_success && !_vm.to_activate
                    ? _c("div", [
                        _c(
                          "div",
                          { staticClass: "form-row justify-content-center" },
                          [
                            _vm._m(3),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-md-12 mb-3 center" },
                              [
                                _c(
                                  "router-link",
                                  {
                                    staticClass: "btn btn-primary",
                                    attrs: { to: "/login" },
                                    nativeOn: {
                                      click: function($event) {
                                        return _vm.resetState($event)
                                      }
                                    }
                                  },
                                  [_vm._v("Accedi")]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ])
                    : !_vm.resend_success &&
                      !_vm.to_activate &&
                      _vm.corporateClient != "emicom"
                    ? _c("div", [
                        _c(
                          "div",
                          { staticClass: "form-row justify-content-center" },
                          [
                            _vm._m(4),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-md-12 mb-3 center" },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-primary mt-3",
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.resendConfirmEmail($event)
                                      }
                                    }
                                  },
                                  [_vm._v("Invia")]
                                )
                              ]
                            )
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.to_activate
                    ? _c("div", [
                        _c(
                          "div",
                          { staticClass: "form-row justify-content-center" },
                          [
                            _c("div", { staticClass: "col-md-12 mb-3" }, [
                              _vm.corporateClient != "hoval"
                                ? _c(
                                    "h4",
                                    {
                                      staticClass:
                                        "mb-4 center text-red sans-serifBold"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          "La tua richiesta è in fase di approvazione."
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("br"),
                                      _c("br"),
                                      _vm._v(
                                        "A breve riceverai la conferma via email e potrai accedere alla piattaforma."
                                      )
                                    ]
                                  )
                                : _c(
                                    "h4",
                                    {
                                      staticClass:
                                        "mb-4 center text-red sans-serifBold"
                                    },
                                    [
                                      _c("strong", [
                                        _vm._v(
                                          "La tua richiesta è in fase di approvazione."
                                        )
                                      ])
                                    ]
                                  )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-md-12 mb-3 center" },
                              [
                                _c(
                                  "router-link",
                                  {
                                    staticClass: "btn btn-primary mt-3",
                                    attrs: { to: "/" }
                                  },
                                  [_vm._v("Home")]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ])
                    : _vm._e()
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._m(5)
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row justify-content-center" }, [
      _c("div", { staticClass: "col-md-12 center " }, [
        _c("h1", { staticClass: "Regular center  pt-4 h0" }, [_vm._v("Accedi")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 text-center" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-primary  btnYellow shadow mb-4 mt-4",
          attrs: { type: "submit" }
        },
        [_vm._v("Accedi")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 col-lg-12 pt-1 " }, [
      _c("div", { staticClass: "row justify-content-center divider" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 mb-3" }, [
      _c("h4", { staticClass: "mb-4 center text-red sans-serifBold" }, [
        _c("strong", [
          _vm._v(
            "L'e-mail di conferma della registrazione è stata inviata alla tua casella di posta elettronica"
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 mb-3" }, [
      _c("h4", { staticClass: "mb-4 center text-red sans-serifBold" }, [
        _c("strong", [
          _vm._v("Non hai ricevuto l'e-mail "),
          _c("br"),
          _vm._v("di conferma della registrazione?")
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "mb-4 mt-5" }, [
        _vm._v(
          "Controlla che il tuo gestore di posta elettronica non abbia inserito il messaggio nella cartella di posta indesiderata (spam) o con destinatario sconosciuto."
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "mb-4" }, [
        _vm._v(
          "Se sono passati diversi minuti da quando hai fatto la richiesta e il messaggio non è ancora arrivato clicca sul bottone qui sotto per chiederne il reinivio."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12 col-lg-12 pt-1" }, [
      _c("div", { staticClass: "row justify-content-center divider" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-70c98a68", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70c98a68","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/index.vue
// module id = null
// module chunks = 